import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import speakers from "./speakers/SpeakersBios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark, faChevronRight } from "@fortawesome/free-solid-svg-icons";

function RegisterInterestStep1({ registerData, onChange, onSubmit, disabled }) {
  const [activeSpeaker, setActiveSpeaker] = useState(null);
  const popupRef = useRef(null);

  // Close popup when clicking outside (for mobile/click)
  useEffect(() => {
    function handleClickOutside(e) {
      if (
        !e.target.closest('.speaker-popup') &&
        !e.target.closest('.speaker')
      ) {
        setActiveSpeaker(null);
      }
    }
    if (activeSpeaker) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [activeSpeaker]);

  // Adjust popup position if it overflows left
  useEffect(() => {
    if (popupRef.current) {
      const rect = popupRef.current.getBoundingClientRect();
      const minMargin = 20;
      if (rect.left < minMargin)
        popupRef.current.style.left = `${minMargin - rect.left + popupRef.current.offsetLeft}px`;
      else if (rect.right > window.innerWidth - minMargin) {
        popupRef.current.style.left = `calc(50% - ${rect.right - (window.innerWidth - minMargin) + minMargin}px)`;
      }
    }
  }, [activeSpeaker]);

  // Helper to handle both click and keyboard (accessibility)
  const handleSpeakerClick = (speaker) => {
    setActiveSpeaker(activeSpeaker && activeSpeaker.name === speaker.name ? null : speaker);
  };


  return (
    <>
      <p>
        On 15-17 June 2026 Serafima and James are putting on the 1st Micro Tanners Conference to be held in the UK, hosted  
        on <Link href="https://greatcotmarshfarm.co.uk" target="_blank" title="Great Cotmarsh Farm website" rel="noopener">Great Cotmarsh Farm</Link> in
        Wiltshire. The conference will be a 3 day event with a mix of talks, panel discussions and a tour 
        of the farm and <Link to="https://cotmarshtannery.co.uk" target="_blank" title="Cotmarsh Tannery CIC website" rel="noopener">Cotmarsh Tannery CIC</Link>.
      </p>
      <p>
        The conference is aimed at anyone interested in learning more about small scale veg tanning, from artisan and craft tanners to the micro tanneries. 
        It is a coming together of tanners and those interested in tanning, to share knowledge, experience and ideas. The focus is on building the momentum 
        of the micro tannery movement in the UK dedicated to the revival of the heritage craft of veg tanning. There will be a focus on developing the commercial viability 
        of small scale tanning, traceability of leather and the local fibre movement (<Link to="https://fibershed.org/" target="_blank" title="Fibreshed website (US)" rel="noopener">Fibresheds</Link>), 
        and where the micro tannery industry is going next.
      </p>
      <p>
        Speakers from across the industry will be sharing their knowledge and experience, and there will be plenty of opportunities
        for discussion and networking. Confirmed speakers, with more to be announced, include:
      </p>

      <ul className="speaker">
        {speakers.map((speaker) => (
          <li key={speaker.name} className="speaker"
            onMouseEnter={() => setActiveSpeaker(speaker)} 
            onMouseLeave={() => setActiveSpeaker(null)}
          >
            {/* Use a div for the speaker to allow click and keyboard interaction */}
            <div
              className="speaker"
              tabIndex={0}
              onClick={() => handleSpeakerClick(speaker)}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") handleSpeakerClick(speaker);
              }}
              aria-haspopup="true"
              aria-expanded={activeSpeaker && activeSpeaker.name === speaker.name}
            >
              <img className="speaker-photo" src={speaker.photo.src} alt={speaker.name}/>
              <div><span className="speaker-name">{speaker.name}</span></div>
            </div>
            {/* Popup for active speaker */}
            {activeSpeaker && activeSpeaker.name === speaker.name && (
              <div className="speaker-popup" ref={popupRef} >
                <img src={speaker.photo.src} alt={speaker.name} />
                <button onClick={() => setActiveSpeaker(null)} >X</button>
                {speaker.photo.credit && (
                  <div className="photo-credit">
                    [photo credit: {speaker.photo.credit}]
                  </div>
                )}
                <div style={{ fontWeight: "bold" }}>{speaker.name}</div>
                <div style={{ fontStyle: "italic", marginBottom: 4 }}>{speaker.company}</div>
                <div>{speaker.bio}</div>
{/*                 
                <div></div>
                <div style={{ display: "flex", justifyContent: "center", gap: 16, margin: "12px 0" }}>
                  {speaker.website && (
                    <a href={speaker.website} target="_blank" rel="noopener noreferrer" title="Website">
                      <i className="fa fa-globe" aria-hidden="true" style={{ fontSize: 22 }}></i>
                    </a>
                  )}
                  {speaker.twitter && (
                    <a href={speaker.twitter} target="_blank" rel="noopener noreferrer" title="Twitter">
                      <i className="fa fa-twitter" aria-hidden="true" style={{ fontSize: 22, color: "#1da1f2" }}></i>
                    </a>
                  )}
                  {speaker.instagram && (
                    <a href={speaker.instagram} target="_blank" rel="noopener noreferrer" title="Instagram">
                      <i className="fa fa-instagram" aria-hidden="true" style={{ fontSize: 22, color: "#e1306c" }}></i>
                    </a>
                  )}
                  {speaker.facebook && (
                    <a href={speaker.facebook} target="_blank" rel="noopener noreferrer" title="Facebook">
                      <i className="fa fa-facebook" aria-hidden="true" style={{ fontSize: 22, color: "#1877f3" }}></i>
                    </a>
                  )}
                </div> */}

              </div>
            )}
          </li>
        ))}
      </ul>
      <p>
        Register your interest to be kept up to date with the latest information about the conference and to be the first to be notified when tickets go on sale.
      </p>
      <form onSubmit={onSubmit} className="conference-form form-narrow">
        <h3>Register your interest</h3>
        <div>
          <label htmlFor="firstname">First Name</label>
          <input
            type="text"
            id="firstname"
            name="firstname"
            value={registerData.firstname}
            onChange={onChange}
            required
          />
        </div>
        <div>
          <label htmlFor="surname">Surname</label>
          <input
            type="text"
            id="surname"
            name="surname"
            value={registerData.surname}
            onChange={onChange}
            required
          />
        </div>
        <div>
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="emailFrom"
            name="emailFrom"
            value={registerData.emailFrom}
            onChange={onChange}
            required
          />
        </div>
        <div>
          <label className="checkbox-container margin-b-20">
            <input 
                type="checkbox" 
                name="subscribeConference" 
                id="subscribeConference" 
                checked={registerData.subscribeConference} 
                onChange={onChange} 
                required
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">Subscribe to conference updates</span>
          </label>
        </div>
        <div>
          <label className="checkbox-container margin-b-20">
            <input 
                type="checkbox" 
                name="subscribe" 
                id="subscribe" 
                checked={registerData.subscribe} 
                onChange={onChange} 
            />
            <span className="custom-checkbox"></span>
            <span className="line-height-1">Subscribe to Cotmarsh Tannery CIC newsletter as well</span>
          </label>
        </div>
        <div>
          <button type="submit" className="primary" disabled={disabled}>
            Register
          </button>
        </div>
      </form>
    </>
  );
}

export default RegisterInterestStep1;